import { getLoanDisplayNo } from 'utils'

export const normalizePipelineLoans = (res: {
  data?: any[]
  additionalData?: Record<string, any>[]
  headers?: string[]
}): Record<string, any>[] => {
  const { data = [], additionalData = [], headers = [] } = res
  if (!data.length) return []

  const loanAmountIndex = headers.findIndex((header) => header === 'Loan Amount')
  const statusIndex = headers.findIndex((header) => header === 'Status')

  if (Array.isArray(data[0])) {
    return data.map((row: any[], index: number) => {
      const meta = additionalData[index] || {}
      return {
        ...meta,
        no: meta.no,
        borrowerName: row[1],
        subjectPropertyAddress: row[2],
        proposedLoanAmount: loanAmountIndex >= 0 ? row[loanAmountIndex] : meta.proposedLoanAmount,
        loanStatus: meta.loanStatus || (statusIndex >= 0 ? row[statusIndex] : undefined),
      }
    })
  }

  return data
}

// Search spans origination and servicing, so a result needs to say which book it is in.
// servicingPipeline comes back from the pipeline query as the string 'true'.
export const isServicingLoan = (loan: Record<string, any>) =>
  loan.servicingPipeline === true || String(loan.servicingPipeline).toLowerCase() === 'true'

export const getBorrowerInitials = (name: string) => {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (!parts.length) return '?'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
}

export const getLoanSearchParts = (loan: Record<string, any>) => {
  const loanNo = getLoanDisplayNo(loan)
  const borrower =
    loan.borrowerName || `${loan.borrowerFirstName || ''} ${loan.borrowerLastName || ''}`.trim()
  const address = loan.subjectPropertyAddress || ''
  return { loanNo, borrower, address }
}

export const buildLoanSearchLabel = (loan: Record<string, any>) => {
  const { loanNo, borrower, address } = getLoanSearchParts(loan)
  const label = [loanNo, borrower, address].filter(Boolean).join(' / ')
  return label || (loanNo ? `Loan #${loanNo}` : '')
}
